import React from "react";
import {useSelector} from "react-redux";
import GroupWithMiddlefacets from "../../components/GroupWithMiddlefacets/GroupWithMiddlefacets";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";

const MiddlefacetsContainer = () => {
    const newFilterState = useSelector(state => state.newFilterReducer);

    let middlefacetsR = [];

    const facets = newFilterState.facets;

    const activeMainFacetID = getActiveMainFacetID(newFilterState);

    if (facets[activeMainFacetID].middlefacets !== undefined) {
        for (const [key, item] of Object.entries(facets[activeMainFacetID].middlefacets)) {
            middlefacetsR.push(<GroupWithMiddlefacets key={key} id={key} value={item.value} facetName={item.facetName} />);
        }
    }

    return (
        <div>
            {middlefacetsR}
        </div>
    );
};

export default MiddlefacetsContainer;
